// V26 — token 化 StatusBadge,4 种状态语义跟随 cyber/comic/standard 切换。
// shadow + text-shadow 用 hsl(var(--xxx) / α) 内联 css 函数,arbitrary value 透传。
const styles: Record<string, string> = {
  success:
    "bg-success/15 text-success border-success/50 shadow-[0_0_10px_hsl(var(--success)/0.35)] [text-shadow:0_0_6px_hsl(var(--success)/0.55)]",
  warning:
    "bg-warning/15 text-warning border-warning/50 shadow-[0_0_10px_hsl(var(--warning)/0.35)] [text-shadow:0_0_6px_hsl(var(--warning)/0.55)]",
  error:
    "bg-destructive/15 text-destructive border-destructive/50 shadow-[0_0_10px_hsl(var(--destructive)/0.35)] [text-shadow:0_0_6px_hsl(var(--destructive)/0.55)]",
  info: "bg-info/15 text-info border-info/50 shadow-[0_0_10px_hsl(var(--info)/0.35)] [text-shadow:0_0_6px_hsl(var(--info)/0.55)]",
};

const dotColors: Record<string, string> = {
  success: "bg-success shadow-[0_0_8px_hsl(var(--success))]",
  warning: "bg-warning shadow-[0_0_8px_hsl(var(--warning))]",
  error: "bg-destructive shadow-[0_0_8px_hsl(var(--destructive))]",
  info: "bg-info shadow-[0_0_8px_hsl(var(--info))]",
};

export function StatusBadge({ type, children }: { type: string; children: React.ReactNode }) {
  const style = styles[type] || styles.info;
  const dot = dotColors[type] || dotColors.info;
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-2xs font-semibold uppercase tracking-[0.08em] border backdrop-blur ${style}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${dot}`} />
      {children}
    </span>
  );
}
